import { getCardStatus } from '@/utilities/defaultCardStatuses';
import cardStatusType from '@/types/cardStatusType';

export default {
  methods: {
    cardStatus(status, propertyName, color = this.lists[this.card.list_id]?.color, isEpic = false) {
      if (Object.values(cardStatusType).includes(status)) {
        this[propertyName] = {
          icon: getCardStatus(status, isEpic).icon,
          color: color || this.card.list_color,
        };
      } else {
        this[propertyName] = {
          icon: getCardStatus(cardStatusType.Backlog, isEpic).icon,
          color: this.lists[this.card.list_id]?.color || this.card.list_color || '#98A2B3',
        };
      }
    },
  },
};
